var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5f6368;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-disabled-other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.3,341c-1.4,0-2.8-0.5-3.8-1.5C39.7,314.2,17,284,0.5,250.3c-0.8-1.6-0.8-3.4,0-5 C49.9,145.1,147.7,82.8,256,82.8c19.3,0,38.5,2,57.4,6c3.1,0.7,5.1,3.7,4.4,6.8s-3.7,5.1-6.8,4.4c-18.1-3.8-36.5-5.8-55-5.8 C153,94.2,59.8,153,12,247.8c15.8,31.4,37.2,59.6,63.1,83.3c2.3,2.1,2.5,5.7,0.4,8C74.4,340.3,72.8,341,71.3,341L71.3,341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,412.8c-40.9,0.1-81.3-8.9-118.4-26.4c-2.8-1.3-4.1-4.7-2.7-7.6c1.3-2.8,4.7-4.1,7.6-2.7l0,0 c35.5,16.7,74.3,25.3,113.5,25.3c103,0,196.2-58.8,244-153.6c-24.7-48.9-62-89.1-108-116.4c-2.7-1.6-3.6-5.1-2-7.8 c1.6-2.7,5.1-3.6,7.8-2c48.8,28.9,88.1,71.6,113.7,123.7c0.8,1.6,0.8,3.4,0,5C462,350.5,364.2,412.8,256,412.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,344.5c-21.1,0.1-41.7-6.8-58.4-19.7c-2.6-1.8-3.3-5.3-1.5-7.9c1.8-2.6,5.3-3.3,7.9-1.5 c0.2,0.1,0.4,0.3,0.5,0.4c14.8,11.3,32.9,17.4,51.5,17.3c47.1-0.1,85.3-38.2,85.3-85.3c0.1-18.6-6-36.7-17.3-51.5 c-2.1-2.4-1.8-6,0.5-8c2.4-2.1,6-1.8,8,0.5c0.2,0.2,0.3,0.4,0.4,0.5c12.9,16.7,19.8,37.3,19.7,58.4 C352.6,301.2,309.3,344.4,256,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.2,247.1h-0.4c-3.1-0.2-5.5-2.9-5.3-6.1c3.4-48.1,41.7-86.3,89.7-89.7c3.1-0.2,5.9,2.2,6.1,5.3 c0.2,3.1-2.2,5.9-5.3,6.1c-42.4,3-76.1,36.7-79.1,79.1C170.6,244.8,168.2,247.1,165.2,247.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,497.8c-3.1,0-5.7-2.6-5.7-5.7c0-1.5,0.6-2.9,1.7-4L492.2,15.5c2.4-2,6-1.6,8,0.9c1.7,2.1,1.7,5.1,0,7.1 L27.7,496.1C26.6,497.2,25.2,497.8,23.6,497.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.55db69e47550276cfc80c3740b21e46e.svg";
export { ForwardRef as ReactComponent };